import React, {useState} from "react";
import {Box, Typography, Menu, MenuItem, IconButton, ListItemIcon, ListItemText, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import moment from "moment";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import {useNavigate} from "react-router-dom";
import UpdateIcon from "@mui/icons-material/Update";
import UpdateStatusDialog from "./update-status.dialog";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useGuard, useRBACStore } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";

const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedGatePass, setOpen, theme, customIconStyles} = props;

    const navigate = useNavigate();
    const {hasPermission} = useGuard();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
    
    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleUpdateStatus = () => {
        setSelectedGatePass(data);
        setOpen(true);
    }

    const menuItems = [
        ...(data?.status === "Active" ? [{
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Details",
            onClick: () => navigate(`/gatepass/view?id=${data.gatepass_uid}`),
            requiredPermission: permissions.gatepass.VIEW_GATEPASS,
        }] : []),
        {
            icon: <BorderColorIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Edit Gate Pass",
            onClick: (e) =>  navigate(`/gatepass/edit?id=${data.gatepass_uid}`),
            requiredPermission: permissions.gatepass.UPDATE_GATEPASS,
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main, fontSize: 23}} />,
            label: "Update Status",
            onClick: (e) => handleUpdateStatus(e, data),
            requiredPermission: permissions.gatepass.CHANGE_STATUS_GATEPASS,
        }
    ].filter((item) => hasPermission(item.requiredPermission))

    
    return (
        <>
            {
                menuItems.length > 0 &&
                <>
                    <IconButton onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{style: {maxHeight: 300}}}
                    >
                        {menuItems?.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    handleClose();
                                    item.onClick();
                                }}
                                sx={{}}
                            >
                                <ListItemIcon sx={customIconStyles}>
                                    {item.icon}
                                </ListItemIcon>
                    
                                <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            }
        </>
    )
}

const ListGatePassComponent = (props) => {
    const {headers, data, isMobile, breakpoints} = props;

    const theme = useTheme();

    const [open, setOpen] = useState(false);
    const [selectedGatePass, setSelectedGatePass] = useState();
    

    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((gatePass) => (
                                <TableRow key={gatePass.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                        {gatePass.plate_number}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        <CustomChipComponent category="gatePassType"
                                            label={(gatePass.pass_type === "Single Entry Pass") ? "Single Entry" 
                                                : 
                                                    (gatePass.pass_type === "Multi Entry Pass") ? "Multi Entry"
                                                :
                                                    (gatePass.pass_type === "Annual Pass") ? "Annual"
                                                :
                                                    (gatePass.pass_type === "Special Entry Pass") ? "Special Entry"
                                                :
                                                    gatePass.pass_type
                                            }
                                        />
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                       {gatePass.entry_type}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        <Box sx={{display: "block"}}>
                                            <Typography sx={{color: theme.typography.primary, fontSize: 14}}>
                                                {moment(gatePass.valid_from).format("MM/DD/YYYY HH:mm A")} - {moment(gatePass.valid_to).format("MM/DD/YYYY HH:mm A")}
                                            </Typography>
                    
                                            <CustomTypography variant="caption" text={`Issued: ${moment(gatePass.created_time).format("MM/DD/YYYY")}`} />
                                        </Box>
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="gatePassStatus"
                                            label={(gatePass.status === "Active") ? "Active" 
                                                : 
                                                    (gatePass.status === "Deactivated") ? "Deactivated"
                                                :
                                                    (gatePass.status === "Suspended") ? "Suspended"
                                                :
                                                    (gatePass.status === "Denied") ? "Denied"
                                                 :
                                                    (gatePass.status === "For Approval") ? "For Approval"
                                                :
                                                    gatePass.status
                                            }
                                        />
                                    </TableCell>

                                    <TableCell align="start">
                                        <CustomMenuPopperComponent 
                                            data={gatePass} 
                                            setOpen={setOpen}
                                            setSelectedGatePass={setSelectedGatePass}
                                            theme={theme}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No gate pass data available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {open && 
                <UpdateStatusDialog 
                    open={open} 
                    setOpen={setOpen} 
                    selectedGatePass={selectedGatePass}
                />
            }
        </Paper>
    )
}

export default ListGatePassComponent